import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IDecorationsService = ( createDecorator('IFileDecorationsService'));
export { IDecorationsService };
